exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins);", ""]);

// Module
exports.push([module.id, ".jobList th div > label {\n  top: 10px !important;\n}\n.jobList tbody tr td:first-child label {\n  margin-left: -50% !important;\n}\n.JobSearchList-module__action_column__15bVd {\n  text-align-last: center;\n}\n:root {\n  --status-color-complete: #ffffff;\n  --status-color-aborted: #d1d0ce;\n  --status-color-queued: #ffc;\n  --status-color-error: #ffd5d5;\n  --status-color-executing: #efe;\n  --status-color-default: #f5f5f5;\n}\n", ""]);

// Exports
exports.locals = {
	"action_column": "JobSearchList-module__action_column__15bVd"
};